module.exports = __webpack_public_path__ + "static/logo-bank-bni-87b7ca454a958c2a814c36dd76b7b694.png";